import type { ReactNode } from 'react';
import type {
  BacklogItemFilterKey,
  DatetimeFilterKeys,
  ItemFilterKey,
  PicklistFilterKeys,
  ResourceFilterKey,
  StringFilterKeys,
  TeamFilterKey,
} from '@/lib/api/types/itemFilters';
import {
  datetimeItemFilterSchema,
  picklistItemFilterSchema,
  stringItemFilterSchema,
} from '@/lib/zod-schemas/itemFilterSearchSchema';

export const picklistItemFilterKeys = Object.keys(
  picklistItemFilterSchema.shape,
) as PicklistFilterKeys[];

export const datetimeItemFilterKeys = Object.keys(
  datetimeItemFilterSchema.shape,
) as DatetimeFilterKeys[];

export const stringItemFilterKeys = Object.keys(stringItemFilterSchema.shape) as StringFilterKeys[];

export type FilterOption = {
  label: string;
  value: string | number;
  icon?: ReactNode;
  component?: ReactNode;
};

export interface ItemFilterConfig {
  key: ItemFilterKey | BacklogItemFilterKey | ResourceFilterKey | TeamFilterKey;
  label: string;
  icon?: ReactNode;
}

export type ItemFilterConfigMap = Partial<
  Record<ItemFilterKey | BacklogItemFilterKey | ResourceFilterKey | TeamFilterKey, ItemFilterConfig>
>;

export type FilterKey = ItemFilterKey | BacklogItemFilterKey | ResourceFilterKey | TeamFilterKey;
